import { Divider, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { PATH_NAME } from '../Routes/Pathname';
import { useNavigate } from 'react-router-dom';
import { AppColors } from '../Utils/helper/AppColors';
import TextLogo from '../Components/TextLogo';
import Navlist from './Navlist';
import { LuLogOut } from 'react-icons/lu';
import useResponsive from '../Utils/hooks/useResponsive';
import { useSelector } from 'react-redux';
import UserThumbnail from '../Components/User/UserThumbnail';
import DeleteConfirm from '../Components/DeleteConfirm';
import { getColorSettings } from '../Utils/helper/commonUtils';

export default function SideBarNav() {
	const navigate = useNavigate();
	const { small } = useResponsive();
	const navBarExpanded = useSelector((state) => state.app.navBarExpanded);
	const user = useSelector((state) => state.app.user);
	const [logoutConfirm, setLogoutConfirm] = useState(false);

	const handleSignOut = async () => {
		localStorage.clear();
		window.location.reload();
		navigate(PATH_NAME.LOGIN);
	};

	const checkBeforeLogOut = () => {
		setLogoutConfirm(true);
	};

		const localSettingColors = getColorSettings();
	

	return (
		<Stack
			py={1}
			gap={1.5}
			top={0}
			width={79}
			height="100vh"
			bgcolor={AppColors.NEW_BACKGROUND}
			position={small ? 'absolute' : 'relative'}
			borderRight="1px solid"
			borderColor={AppColors.BORDER_GREY}
			zIndex={5}
			sx={{ transform: `translateX(${!small ? '0%' : navBarExpanded ? '0' : '-100%'})`, transition: 'all .2s' }}
		>
			{/* tej */}
			<TextLogo img onClick={() => navigate(PATH_NAME.DASHBOARD)} />
			<Divider />
			<Navlist />

			<Stack
				pt={2}
				pb={1}
				gap={1.4}
				maxWidth="100%"
				direction="column"
				justifyContent="center"
				alignItems="center"
				borderTop="1px solid"
				borderColor={AppColors.BORDER_COLOR}
				mt="auto"
			>
				<UserThumbnail size={30} thumbnail hideName user={user} />
				{/* <Stack
					ml={1}
					sx={{
						'& .MuiTypography-root': {
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							maxWidth: 148,
						},
					}}
				>
					<Typography fontSize={12} fontWeight={600} color={AppColors.TEXT_SECONDARY}>
						{`${user?.firstName || ''} ${user?.lastName}`}
					</Typography>
					<Typography fontSize={12} fontWeight={400} color={AppColors.TEXT_TERTIARY}>
						{user?.email}
					</Typography>
				</Stack> */}
				<LuLogOut onClick={checkBeforeLogOut} color={localSettingColors.buttonBackground} size={18} cursor="pointer" />
			</Stack>

			<DeleteConfirm
				loading={!logoutConfirm}
				open={logoutConfirm}
				onDelete={handleSignOut}
				onClose={() => setLogoutConfirm(false)}
				title="Logout Confirmation?"
				subTitle="Are you sure you want to logout?"
			/>
		</Stack>
	);
}
